import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PermissionsService } from 'src/services/PermissionsService';
import { CcService } from '../../../../services/cc.service';
import { DataService } from '../../../../services/data.service';
import { PrdLocationService } from '../../../../services/prdLocation.service';
import { RouterService } from '../../../../services/router.service';
import { SecurityService } from '../../../../services/security.service';
import { Icc } from '../../../Interfaces/icc';
import { IlocationslistResponse, locationslist, PrdLocationSystemStatus } from '../../../Interfaces/ilocation';
import { IuserPermissionsResponse } from '../../../Interfaces/iuser';
import { ErrorStateMatcher1 } from '../../../error-state-matcher1';
import { AddLocationProductionComponent } from '../Production/addlocationproduction.component';
import { EditLocationProductionComponent } from '../Production/editlocationproduction.component';

@Component({
  selector: 'app-prdlocationlist',
  templateUrl: './prdlocationlist.component.html'
})

export class PrdLocationsListComponent implements OnInit {

  formReport: FormGroup;
  subRef$: Subscription;
  r_gridregs: 0;
  public companyId: string;
  userId: string;
  matcher = new ErrorStateMatcher1();
  message: string = "";
  Columns: string[] = [];
  DataGrid: IlocationslistResponse[] = [];
  dataList = null;
  Permissions: IuserPermissionsResponse[] = [];
  MenuG: IuserPermissionsResponse[] = [];
  permissionsList = null;
  menuPop: IuserPermissionsResponse[] = [];
  menuPopList = new MatTableDataSource;
  menuGList = new MatTableDataSource;
  statuslist: PrdLocationSystemStatus[] = [];
  filtermenu = { type: 'G' };
  _currentId: number;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private dataService: DataService,
    private securityService: SecurityService,
    private routeparent: RouterService,
    private securityParams: ActivatedRoute,
private prdLocationService: PrdLocationService,
    private permissionsService: PermissionsService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private routerService: RouterService

  ) {
    this.formReport = formBuilder.group({
      //cc_id: [null, Validators.required],
      status:["A", Validators.required],
      validator:['x', Validators.required]
    });
    this.statuslist.push({ code: "A", name: "Activo" }, { code: "I", name: "Inactivo" });
    this.Columns = ['code', 'name', 'statusname',  'b_menu'];
  }
  selectedvalue: number; selectedview: string;
  cc: Icc[];
  ccId: number;


  ngOnInit() {
    this.ccId = parseInt(this.securityParams.snapshot.params.ccid);
    this.message = "";
    //permisos
    this.Permissions = [];
    this.MenuG = [];
    this.menuPop = [];
    this.permissionsService.getPermission("PRDLOCATIONS").subscribe(results => {
      if (results.body.length == 0)
        this.message = "No tiene permisos";
      for (const entry of results.body) {
        this.addPermission({ id: entry.id, function_code: entry.function_code, code: entry.code, description: entry.description, type: entry.type, icon: entry.icon, link: entry.link });
      }
    },
      (e) => {
        this.message = e.error;
        console.log(e);
      });
    this.permissionsList = new MatTableDataSource<IuserPermissionsResponse>(this.Permissions);
    this.menuGList = new MatTableDataSource<IuserPermissionsResponse>(this.MenuG);
    this.menuPopList = new MatTableDataSource<IuserPermissionsResponse>(this.menuPop);

  }


  filter() {
    //location
    const localist: locationslist = {
      cc_id: this.ccId,
      status: this.formReport.value.status,
      type: "L"
    };
    this.message = "Consultando...";
    this.formReport.controls['validator'].setValue("");
    this.DataGrid = [];
    this.r_gridregs = 0;
    this.prdLocationService.List(localist).subscribe(results => {
      if (!results.body.isValid) {
        this.message = results.body.error.description;
        this.formReport.controls['validator'].setValue("x");
      }
      for (const entry of results.body.resultData) {
        //this.addData({ id: entry.id, code: entry.code, name: entry.name, status: entry.status, statusname: entry.statusname, cccode: entry.cccode });
        this.addData({ id: entry.id, code: entry.code, name: entry.name, status: entry.status, statusname: entry.statusname});
      }
      this.dataList = new MatTableDataSource<IlocationslistResponse>(this.DataGrid);
      this.r_gridregs = this.dataList.data.length;
      this.message = "";
      this.formReport.controls['validator'].setValue("x");
    },
      (e) => {
        alert(e.error);
      });
  }


  addData(data) {
    this.DataGrid.push(data);
  }

  addPermission(permission) {
    this.Permissions.push(permission);
    switch (permission.type) {
      case "G":
        this.MenuG.push(permission);
        break;
      case "R":
        this.menuPop.push(permission);
        break;
    }
  }

  addCc(V_cc) {
    try {
      this.cc.push(V_cc);
    }
    catch (e) {
      console.log(e);
    }
  }

  b_CurrentId(p_Id: number) {
    this._currentId = p_Id;
    //    this.appcustomerlistservice.putValues(this.formFilter.value.name, this.formFilter.value.idNumber, this.formFilter.value.status, this.paginator.pageIndex);
  }


  b_Production() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = "my-class";
    let dialogRef = null;
    this.prdLocationService.IsProduction(this.prdLocationService.locationID).subscribe(result => {
      if (result.body.isValid) {
        dialogRef = this.dialog.open(EditLocationProductionComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(
          data => {
            if (data) {
              console.log("grabado");
            }
            else {
              console.log('Undefined data.');
            }
          }, (e) => console.log(e)
        );
      }
      else {
        if (result.body.resultCode == 204) {
          dialogRef = this.dialog.open(AddLocationProductionComponent, dialogConfig);
          dialogRef.afterClosed().subscribe(
            data => {
              if (data) {
                console.log("grabado");
              }
              else {
                console.log('Undefined data.');
              }
            }, (e) => console.log(e)
          );
        }
        else {
          alert(result.body.error.description);
        }
      }
    })
  }

  //execute menu options
  b_ExecutePop(PFunctionCode: string, PPrmCode: string, PLink: string) {
    //this.routeparent.putRouter("customerlist");
    var _Location = this.DataGrid.find(x => x.id == this._currentId);
    this.prdLocationService.putValues(this._currentId, _Location.name);
    switch (PPrmCode) {
      case "P":
        this.b_Production();
        break;
    }
  }

  b_add(id, name) {
    this.routeparent.putRouter("locationslist");
    this.prdLocationService.putValues(id, name)
    this.router.navigate(['locationadd']);

  }



  b_gen(link, id) {
    //this.routeparent.putRoute("locationslist" + "/" + this.ccId);
    let _route = link + "/" + this.ccId;
    this.router.navigate([_route]);
    //this.router.navigate([link]);
  }

  b_back() {
    this.routerService.getBackRoute();
    this.router.navigate([this.routerService.routerParent], { skipLocationChange: true });

    //this.router.navigate(['data']);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

}
